import { render, staticRenderFns } from "./NewTabGeneral.vue?vue&type=template&id=6c9b599c&"
import script from "./NewTabGeneral.vue?vue&type=script&lang=js&"
export * from "./NewTabGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports